import App from '@components/misc/SpecialEditionModal.vue'
import { generateApplication } from '@helpers/generate_component.js';
import { autoAnimatePlugin } from "@formkit/auto-animate/vue"

generateApplication(App, "#specialEditionModal")
